import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import React from 'react';
import ProposalSidebar from '../ProposalSidebar';

const ProposalStatusLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <GlobalLayout leftSection={<ProposalSidebar />} rightSection={children} />;
};

export default ProposalStatusLayout;
